import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles<{ disabled: boolean }>()((theme, {
    disabled,
}) => {
    return {
        root: {},
        checkboxRoot: {
            padding: '1px 3px 1px 9px !important',
            fill: 'white',
            color: disabled ? `${theme.palette.secondary[500]} !important` : theme.palette.secondary[700],
        },
        checkboxWrapper: {
            paddingTop: theme.spacing(2),
            '& .MuiFormControlLabel-label': {
                color: `${theme.palette.secondary[900]} !important`,
            },
        },
        requiredMark: {
            '&&': {
                position: 'absolute',
                left: 9,
                width: 4,
                height: 27,
                backgroundColor: theme.palette.primary.main,
                display: 'none',
                borderRadius: 3,
            },
        },
    }
})

export default useStyles
